<template>
  <div class="video__l">
    <p class="bread">
      <router-link
        style="text-decoration: none; color: var(--font-color)"
        to="/"
      >
        فروشگاه اینترنتی شمع خورشید
      </router-link>

      <router-link
        style="text-decoration: none; color: var(--font-color)"
        to="/video/list"
      >
        / لیست و یدیوها
      </router-link>
    </p>

    <div class="con">
      <div class="video__l__container">
        <div class="video__l__container__sub">
          <router-link
            :key="(item, index)"
            v-for="(item, index) in items"
            class="video__l__container__sub--item"
            :to="{
              name: 'video_detail',
              params: { id: item.id, num: 1 },
            }"
          >
            <div class="con2">
              <img
                class="video__l__container__sub--item-img"
                :src="item.image"
                alt=""
              />
              <div class="con3">
                <font-awesome-icon
                  class="video__l__container__sub--item-svg"
                  icon="step-forward"
                />
              </div>
            </div>
            <div class="con654">
              <p class="video__l__container__sub--item-text">
                {{ item.title }}: &nbsp;
              </p>
              <p
                class="video__l__container__sub--item-text"
                v-html="item.description"
              ></p>
            </div>
          </router-link>
        </div>
      </div>

      <div class="pagination-con" v-if="ddd != 1">
        <paginate
          v-model="pagee"
          :page-count="page"
          :click-handler="clickCallback"
          :prev-text="'قبلی'"
          :next-text="'بعدی'"
          :container-class="'pagination'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
// import "../src/custom-theme.css";
// Similarly, you can also introduce the plugin resource pack you want to use within the component
// import "some-video__ljs-plugin";
import Paginate from "vuejs-paginate";

export default {
  data() {
    return {
      // hhh: 0,
      ddd: 0,
      pagee: 0,
      page: 0,
      items: [],
      playerOptions: {
        // video__ljs options
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: "video/mp4",
            src: "http://vjs.zencdn.net/v/oceans.mp4",
          },
        ],
        poster: "https://picsum.photos/300/210",
      },
    };
  },
  destroyed() {
    sessionStorage.setItem("vpage", "");
  },
  created() {
    var that = this;
    // that.hhh = this.$route
    that.$store.state.load = true;
    if (sessionStorage.getItem("vpage")) {
    } else sessionStorage.setItem("vpage", 1);
    that.pagee = parseInt(sessionStorage.getItem("vpage"));
    $.ajax({
      url:
        that.$store.state.url +
        "api/v1/teaching/playlist/?page=" +
        sessionStorage.getItem("vpage"),
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data);
        that.$store.state.load = false;
        // that.pagee = data.count;
        that.page = data.lastPage;
        that.items = data.results;
        that.ddd = data.lastPage;
      },
      error: function (request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function () {
        scroll(0, 0);
      },
    });
  },
  mounted() {
    // console.log("this is current player instance object", this.player);
  },
  computed: {
    player() {
      //   return this.$refs.video__lPlayer.player;
    },
  },
  components: {
    Paginate,
  },
  methods: {
    clickCallback(pageNum) {
      var that = this;
      that.$store.state.load = true;
      sessionStorage.setItem("vpage", parseInt(pageNum));
      $.ajax({
        url:
          that.$store.state.url + "api/v1/teaching/playlist/?page=" + pageNum,
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.$store.state.load = false;
          // that.pagee = data.count;
          // that.page = data.lastPage;
          that.items = data.results;
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {
          scroll(0, 0);
        },
      });
    },
  },
};
</script>
<style lang="scss">
.con {
  //   position: relative;
  //   direction: rtl;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.164);
  width: 95%;
  height: 100%;
  background: var(--main-color);
  padding: 2em;
  @media screen and (max-width: 900px) {
    padding: 2em;
  }
  @media screen and (max-width: 500px) {
    padding: 1em;
    // padding-top: 2em;
  }
}
.video__l-js {
  width: 100%;
  height: 450px;
  @media screen and (max-width: 1100px) {
    height: 350px;
  }
  @media screen and (max-width: 900px) {
    height: 350px;
  }
  @media screen and (max-width: 900px) {
    height: 300px;
  }

  // margin-right: 0.5em;
  // margin-right: 3em;
}
.video__l-player-box {
  // box-shadow: 0 0 1px rgba(0, 0, 0, 0.247);
}
.video__l {
  margin-top: 10em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &__container {
    // position: relative;
    direction: rtl;
    border-radius: 8px;
    // box-shadow: 0 0 5px rgba(0, 0, 0, 0.164);
    // width: 100%;
    // height: 500px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    background: var(--main-color);
    // padding: 2em;

    &__sub {
      // margin-right: 2.2em;
      // background: red;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      //   flex-direction: ;
      // background: red;
      width: 100%;
      height: 100%;
      //   overflow-x: hidden;
      scrollbar-width: thin;
      scrollbar-color: var(--bg-color) var(--main-color);
      border-radius: 5px;
      // margin-left: -2em;
      //   margin-right: 1em;
      // margin-top: -1em;
      flex-wrap: wrap;
      @media screen and (max-width: 900px) {
        // width: 100%;
      }
      &--item {
        transition: all 0.5s;
        &:hover {
          // background: rgba(222, 228, 255, 0.527);
          // color: honeydew;
        }
        &:hover .con3 {
          // width: 100%;
          // background: none;
        }
        color: var(--font-color);
        border: 1px solid rgb(235, 235, 255);
        border-radius: 5px;
        margin-bottom: 0.5em;
        background: var(--bg-color);
        display: flex;
        padding: 1em;
        // margin-left: 0.5em;
        text-decoration: none;
        justify-content: center;
        align-items: center;
        width: 49%;
        // margin-right: -1.5em;
        // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.13);
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.103);
        @media screen and (max-width: 800px) {
          width: 100%;
        }
        &-svg {
          color: var(--sub-color);
          font-size: 1em;
          position: absolute;
          @media screen and (max-width: 500px) {
            font-size: 0.7em;
          }
          // background: var(--main-color);
          // width: 200px;
          // height: 100%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          // padding: 0.15em;
          // width: 100px;
          // height: 0px;
          border-radius: 50%;
          // margin: 2em;
        }
        &-img {
          position: absolute;
          width: 100%;
          height: 100%;
          @media screen and (max-width: 900px) {
            width: 100%;
          }
        }
        &-text {
          width: 100%;
          font-size: 0.7em;
          text-align: justify;
          display: flex;
          @media screen and (max-width: 900px) {
            font-size: 0.5em;
          }
          // margin-right: 5em;
        }
      }
    }
  }
}
.con2 {
  //   background: red;
  position: relative;
  margin-left: 1em;
  width: 135px;
  height: 110px;
  @media screen and (max-width: 900px) {
    width: 150px;
  }
  @media screen and (max-width: 900px) {
    height: 80px;
  }
}
.video__l-player-box {
  // margin-left: 1em;1
}
.con3 {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(240, 255, 240, 0.61);
  transition: all 0.5s;
}
.pagination-con {
  //   background: chartreuse;
  width: 100%;
}
.pagination {
  justify-content: space-evenly;
  align-items: center;
  display: flex;
  // background: red;
  // padding: 1.5em 20em;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  @media screen and (max-width: 500px) {
    width: 100%;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  // background: var(--bg-color);
  li {
    margin: 0 4px;
    padding: 0;
    list-style: none outside none;
    line-height: 5px;
    width: 100%;
    // background: chartreuse;
    a {
      border-radius: 3px;
      // background: var(--bg-color);
      // color: var(--font-color);
      // padding: 1em
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.9em;
      @media screen and (max-width: 500px) {
        font-size: 0.5em;
      }
    }
  }
  .active {
    color: var(--main-color);
    background: var(--sub-color);
  }
}
.page-item {
  border-radius: 3px;
  background: var(--bg-color);
  color: var(--font-color);
  // padding: 1em
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9em;
  @media screen and (max-width: 500px) {
    height: 25px;
  }
}
.con654 {
  display: flex;
  flex-direction: column;
  width: 90%;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}
.bread {
  direction: rtl;
  margin-left: auto;
  margin-right: 3em;
  margin-top: -0.5em;
  margin-bottom: 1em;
  // margin-right: 0.6em;
  // margin: 1em;
  align-self: flex-start;
  font-size: 0.8em;
  @media screen and (max-width: 800px) {
    font-size: 0.6em;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/video/video_list.vue